import React, { useState } from 'react';
import { Bell, Megaphone, Check, Info, AlertTriangle, ShieldCheck } from 'lucide-react';

function Notifications({ notifications, setNotifications, role, showToast }) {
  const [localNotifications, setLocalNotifications] = useState(notifications);

  React.useEffect(() => {
    setLocalNotifications(notifications);
  }, [notifications]);

  const markOne = (id) => {
    const updated = localNotifications.map(n => 
      n.id === id ? { ...n, read: true } : n
    );
    setLocalNotifications(updated);
    setNotifications(updated);
  };

  const markAll = () => {
    const updated = localNotifications.map(n => ({ ...n, read: true }));
    setLocalNotifications(updated);
    setNotifications(updated);
    showToast('All read', 'ok');
  };

  const openAnn = () => {
    showToast('Announcement feature coming soon', 'inf');
  };

  const unreadCount = localNotifications.filter(n => !n.read).length;

  const getNotificationBackground = (type) => {
    switch (type) {
      case 'leave': return 'var(--accent-bg)';
      case 'alert': return 'var(--amber-bg)';
      case 'payroll': return 'var(--green-bg)';
      default: return 'var(--surface2)';
    }
  };

  return (
    <div className="pg">
      <div className="ph">
        <div>
          <h1>Notifications</h1>
          <p>{unreadCount} unread</p>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          {role === 'hr' && (
            <button className="btn btn-p" onClick={openAnn} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Megaphone size={16} /> Announce
            </button>
          )}
          <button className="btn btn-g" onClick={markAll} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Check size={16} /> Mark all read
          </button>
        </div>
      </div>
      <div className="card" id="nlist">
        {localNotifications.map(notification => (
          <div
            key={notification.id}
            className={`nr ${notification.read ? '' : 'unread'}`}
            onClick={() => markOne(notification.id)}
          >
            <div
              className="nic"
              style={{ background: getNotificationBackground(notification.type) }}
            >
              {notification.icon}
            </div>
            <div style={{ flex: 1 }}>
              <div className="nt">
                {notification.title}
                {!notification.read && (
                  <span className="bx bb" style={{ marginLeft: '6px', fontSize: '10px' }}>
                    New
                  </span>
                )}
              </div>
              <div className="nb">{notification.body}</div>
              <div className="nm">â± {notification.time}</div>
            </div>
          </div>
        ))}
        {localNotifications.length === 0 && (
          <div style={{ textAlign: 'center', padding: '40px', color: 'var(--text3)' }}>
            No notifications yet
          </div>
        )}
      </div>
    </div>
  );
}

export default Notifications;
